/*
  "Brands we've worked with" (client, 2026-10-07 / 2026-10-08). Foot of the 2nd
  landing section: a section-size centred heading, then the logos on the shared
  LogoRail, full viewport width. Black cuts of the sponsor files so they read
  on the light band. Sizes live in components.css (.gm-brands .gm-rail__item img).
*/
import { LogoRail } from "./LogoRail";

// Client, 2026-10-08: everything stays here (Akaria / Akaari included - past
// partners), Pixel Co added. Client, 2026-10-22: Paint Protection Solutions
// (PPS) is no longer a season sponsor - gone from the Ultimate Lap rail, the
// footer and the emails - but it STAYS here: this is "Brands we've worked
// with", and they have.
export const BRAND_LOGOS = [
  { src: "/brand/sponsors/black/pirelli.webp", name: "Pirelli" },
  { src: "/brand/sponsors/black/AKARIA.webp", name: "Akaria" },
  { src: "/brand/sponsors/black/PPS.webp", name: "Paint Protection Solutions" },
  { src: "/brand/sponsors/black/atmoic.webp", name: "Atomic" },
  { src: "/brand/sponsors/black/mission-motorsport.webp", name: "Mission Motorsport" },
  { src: "/brand/sponsors/black/Layer_1.webp", name: "Akaari" },
  { src: "/brand/sponsors/black/pixelco.webp", name: "Pixel Co" },
];

export function LogoStrip({ logos = BRAND_LOGOS, heading = "Brands we've worked with", speed = 36, testid = "brand-strip" }) {
  return (
    <div className="gm-brands" id="partners" data-testid={testid}>
      <div className="container-gm">
        <div className="gm-brands__head">
          <h2 className="display-md gm-brands__title" data-reveal="mask" data-testid={`${testid}-heading`}>{heading}</h2>
        </div>
      </div>
      <LogoRail logos={logos} speed={speed} className="gm-rail--light" testid={`${testid}-rail`} label={heading} />
    </div>
  );
}
